import { Button, Card, CardContent, Grid, Link , DialogContentText} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { deleteIcon, digital, downloadIcon, lockIcon } from "../assets";
import { CHANNELS, GLOBAL_ACTION } from "../types/global.enum";
import { DataGrid, Modal, SearchInput } from "../ui"
import { AddProject } from "./addProject";
import PhoneEnabledOutlinedIcon from '@mui/icons-material/PhoneEnabledOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import { deleteProjects, getProjectList, exportProjects } from "../services/project.service";
import TextsmsOutlinedIcon from '@mui/icons-material/TextsmsOutlined';
import { useNavigate } from "react-router-dom";
import { formatDate } from "../helpers/date.helper";
import { useAppDispatch } from "../store/hooks";
import { setCurrentProject } from "../store/resuders/project.reducer";
import { hideSegmentLibrary, setBatchSegments, setEditSegment, upsertLibrary as upsertSegmentLibrary } from '../store/resuders/segment.reducer';
import { serGrammaroptions, showHelpDetails, toggleAlert } from "../store/resuders/app.reducer";
import { formatTimestamp } from "../helpers/date.helper";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import { getHelpCenter } from "../store/selectors/app.selector";
import InfoIcon from '@mui/icons-material/Info';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import { uniqueId } from '../helpers/form.helper';
import { ImportProjects } from "../ui/importProjects";
import { ImportData } from "../ui/importData";

// GLOBAL LIBRARY
import { SegmentEditor } from './segmentEditor';
import { DigitalSegmentEditor } from './digital/digitalSegmentEditor';
import { GlobalLibrary } from './globalLibrary';
import { upsertVariable as upsertLibraryVariable } from '../store/resuders/variable.reducer';
import { upsertGrammar as upsertLibraryGrammar } from '../store/resuders/grammar.reducer';
import { upsertPrompt as upsertLibraryPrompt } from '../store/resuders/prompt.reducer';
import { upsertAudio as upsertLibraryAudio } from '../store/resuders/audio.reducer';
import { allowUpsertLibrary } from '../store/selectors/segment.selector';
import { allowUpsertVariable } from '../store/selectors/variable.selector';
import { allowUpsertGrammar } from '../store/selectors/grammar.selector';
import { allowUpsertPrompt } from '../store/selectors/prompt.selector';
import { allowUpsertAudio } from '../store/selectors/audio.selector';
import { LibraryEditor } from '../ui/libraryEditor';
import { getProjectById } from '../services/project.service';
import { getGrammarOptions } from '../services/grammar.service';
import { getCurrentProject, getCurrentTestCase, selectBrowsers } from '../store/selectors/project.selector';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { setCurrentProjectId, setCurrentTestCase } from '../store/resuders/project.reducer';

export const ProjectList = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const history = useNavigate();
    const [action, setAction] = useState<GLOBAL_ACTION>(GLOBAL_ACTION.NONE);
    const [edit, setEdit] = useState<any>(null);
    const [data, setData] = useState<any>([]);
    const [remove, setRemove] = useState<any>([]);
    const [projectExport, setProjectExport] = useState<any>([]);
    const [isOpen, setIsOpen] = useState<string>('');
    const helpCenter = useSelector(getHelpCenter);
    const [openImport, setOpenImport] = useState('');

    // Global Library
    const [showSegmentEditor, setShowSegmentEditor] = useState(false);
    const [editorOpen, setEditorOpen] = useState(false);
    const [editorState, setEditorState] = useState("")
    const [selectedData, setSelectedData] = useState<any>([]);
    const [globalLibraryOpen, setGlobalLibraryOpen] = useState(false);
    const [editorSource, setEditorSource] = useState<string>('ProjectLibrary');
    const upsertLibrary = useSelector(allowUpsertLibrary);
    const upsertVariable = useSelector(allowUpsertVariable);
    const upsertGrammar = useSelector(allowUpsertGrammar);
    const upsertPrompt = useSelector(allowUpsertPrompt);
    const upsertAudio = useSelector(allowUpsertAudio);
    const [caseEditorOpen, setCaseEditorOpen] = useState(false);
    const [segmentAddTestCaseEditor, setSegmentAddTestCaseEditor] = useState<boolean>(false);
        const [projectLibraryOpen, setProjectLibraryOpen] = useState(false);
         const [openDiscardConfirmation, setOpenDiscardConfirmation] = useState('');
            
    
    const [criteria, setCriteria] = useState<any>({
        sort: '-lastModifiedTime',
        pageNo: 0,
        pageSize: 10,
        filter: '',
    });

    const columns: any[] = [{ key: true, caption: t('ID'), width: '5%', fieldName: 'testProjectID', sortable: true },
    {
        caption: t('Channel'), width: '5%', fieldName: 'channelType', sortable: true,
        redner: (param: any) => <div className="flex-center justify-center">{param.channelType === CHANNELS.VOICE ? (<PhoneEnabledOutlinedIcon style={{ fontSize: '17px' }} />) : (<img src={digital} alt="" width={17}/>)}</div>
    },
    {
        fieldName: 'name', caption: t('Project Name'), sortable: true, width: '75%',
        redner: (params: any) => <div className="flex-center">
            <Link onClick={gotoTestCase(params)} className="a-link-black">{params.name}</Link><BorderColorOutlinedIcon onClick={editProject(params)} style={{ fontSize: '17px', cursor: 'pointer' }} /></div>
    }, {
        fieldName: 'lastModifiedTime', caption: t('Modified'), sortable: true, width: '15%',
        // redner: (param: any) => <div>{formatDate(param.lastModifiedTime)}</div>
        redner: (param: any) => <div>{formatTimestamp(param.lastModifiedTime)}</div>
    }];

    const gotoTestCase = (project: any) => () => {
        dispatch(setCurrentProject(project));
      //  dispatch(upsertLibrary(''));
        dispatch(setEditSegment(null));
      ///  dispatch(clearSegments());
        // history(`/testcase`);
        history(`/projects/${project.testProjectID}/testcases`);
    }

    const editProject = (data: any) => () => {
        setEdit(data);
        setAction(GLOBAL_ACTION.EDIT);
    }

    const importClosed = ()=>{
        setOpenImport('');
    }

    const updateAction = () => {
        switch (action) {
            case GLOBAL_ACTION.NONE: {
                setAction(GLOBAL_ACTION.ADD);
                break;
            }

            default: {
                setAction(GLOBAL_ACTION.NONE);
                setEdit(null);
            }
        }
    }

    const onDone = async () => {
        setAction(GLOBAL_ACTION.NONE);
        setEdit(null);
        await loadData();
    }

    const sortChanged = (column: string, direction: string) => {
        setCriteria({
            ...criteria,
            pageNo: 0,
            sort: `${direction === 'ASC' ? '+' : '-'}${column}`,
        })
    }

    const pageChanged = (page: number) => {
        setCriteria({
            ...criteria,
            pageNo: page - 1,
        })
    }

    const onFilterChanged = (filter: string) => {
        setCriteria({
            ...criteria,
            pageNo: 0,
            filter,
        })
    }

    const pageSizeChanged = (size: number) => {
        setCriteria({
            ...criteria,
            pageSize: size,
            pageNo: 0,
        })
    }

    const loadData = async () => {
        const { data } = await getProjectList(criteria.pageNo, criteria.pageSize, criteria.sort, criteria.filter);
        setData(data)
    }


    const deleteProject = useCallback(async () => {
        try {
            await deleteProjects(remove);
            await loadData();
            setRemove([]);
        } catch (error:any) {
            dispatch(toggleAlert("Projects with existing test cases cannot be deleted")); // Dispatch toggleAlert action with an error alert
        }
    },[remove]);

    const deleteSelected = async () => {
        if (remove?.length) {
            setIsOpen(`${new Date().getTime()}`);
        }
    }

    const exportProject = async () => {
        await exportProjects(remove);
        await loadData();
        setRemove([]);
    }

    const importProject =  async () => {
        setOpenImport(uniqueId());
    }

    const selectionChanged = useCallback((id: any) => {
        setRemove(id);
    },[])

    useEffect(() => {
        loadData();
        dispatch(setCurrentProject(null));
    }, [criteria])

      // Global Library

    const [discardChangeConfirmation, setDiscardChangeConfirmation] = useState<any>({
            callAfter: () => {},
            onConfrimAction: ()=> {},
            onDiscardAction: ()=> {}
        });
       const toggleCaseEditor = () => {
              if (!caseEditorOpen) {
                  dispatch(setCurrentTestCase(null));
                  dispatch(setBatchSegments([]));
              }
      
              setCaseEditorOpen(!caseEditorOpen);
              setEdit(null);
              setShowSegmentEditor(false)
              setProjectLibraryOpen(true);
          };
      
          const toggleGlobalLibrary = () => {
              setGlobalLibraryOpen(!globalLibraryOpen);
              setProjectLibraryOpen(false);
          };
      
          const toggleProjectLibrary = () => {
              setProjectLibraryOpen(!projectLibraryOpen);
              setGlobalLibraryOpen(false);
          };
      
          const toggleSegmentEditor = (close?: boolean, open?: boolean) => {
              if (open) {
                  setShowSegmentEditor(true);
              } else if (close) {
                  setShowSegmentEditor(false);
                  dispatch(hideSegmentLibrary());
              } else {
                  setShowSegmentEditor(!showSegmentEditor); // Toggle the showSegmentEditor state
              }
          };
    
      let gridItemSize = 12;
      if (upsertLibrary || upsertVariable || upsertGrammar || upsertPrompt || upsertAudio) {
          gridItemSize = 4;
      } else if (caseEditorOpen && showSegmentEditor && (globalLibraryOpen)) {
          gridItemSize = 4;
      } else if (caseEditorOpen && (globalLibraryOpen  || showSegmentEditor)) {
          gridItemSize = 6;
      } else if (globalLibraryOpen ) {
          gridItemSize = 6;
      } else {
          gridItemSize = 12;
      }
  
  
      const getTabType = () => {
          if (upsertVariable) {
              return "Variable"
          } else if (upsertGrammar) {
              return "Grammar"
          } else if (upsertPrompt) {
              return "Prompt"
          } else if (upsertAudio) {
              return "Audio"
          }
      }

    
    //   const goToTestCases = async () => {
    //     if (!currentTestCase) return;
    //     await loadData();
    //     setCaseEditorOpen(false);
    //     setEdit(null);
    //     setShowSegmentEditor(false)
    //     dispatch(setEditSegment(null));
    //     dispatch(upsertSegmentLibrary(''))
    //     dispatch(upsertLibraryAudio(''))
    //     dispatch(upsertLibraryGrammar(''))
    //     dispatch(upsertLibraryPrompt(''))
    //     dispatch(upsertLibraryVariable(''))
    // }

    const checkIsAnyEditorOpen  = () => showSegmentEditor || editorOpen;

    const text = (<>
        <DialogContentText sx={{
                        fontSize: "16px",
                        color: '#000000',
                        textAlign: "center",
                        fontFamily: 'Roboto',
                        mt: 5,
                        mb: 5,
                    }}>
                    <div>
                        <ErrorOutlineIcon style={{ fontSize: '50px', color: '#FD5900', paddingBottom: '33px' }} />
                    </div>
                    {`Do you want to save the changes to the ${getTabType()} Library?`}
        </DialogContentText>
    </>);

    // const handleDiscardChangeConfirmation = async () => {
    //     await discardChangeConfirmation?.onConfrimAction();
    //     discardChangeConfirmation.callAfter();
    // }
    



    return (
        <DndProvider backend={HTML5Backend}>
            <Grid container>
                <Grid item xs={12} className="flex justify-end align-center gap-8" textAlign="right" marginBottom={'16px'}>
                     {/* Global Library */}
                     <Button
                        variant={globalLibraryOpen ? 'outlined' : 'contained'}
                        color="primary"
                        onClick={toggleGlobalLibrary}
                    >
                        {globalLibraryOpen ? t('Close Library') : t('Global Library')}
                    </Button>
                    {helpCenter && <div onClick={()=>dispatch(showHelpDetails('Add a Project'))} className="help-icon"><InfoIcon /></div>}<Button variant={action !== GLOBAL_ACTION.NONE ? "outlined" : "contained"} color="primary" onClick={updateAction}>{t(action !== GLOBAL_ACTION.NONE ? 'Close' : 'Add Project')}</Button>
                </Grid>

                <Grid item xs={gridItemSize}>
                    <Card>
                        <CardContent>
                            <div className="action-header">
                                {/* <img src={lockIcon} alt="" /> */}
                                <img src={deleteIcon} alt="Remove" onClick={deleteSelected} />{helpCenter && <div onClick={()=>dispatch(showHelpDetails('Project Page'))} className="help-icon"><InfoIcon /></div>}
                                <img src={downloadIcon} alt="Export" onClick={exportProject} />
                                <ArrowCircleUpIcon onClick={importProject}  />
                                <div className="flex-end">
                                    <SearchInput onFilter={onFilterChanged} />
                                </div>
                            </div>

                            <DataGrid pageChanged={pageChanged} totalPages={data?.totalPages || 0} sortChanged={sortChanged} columns={columns} data={data?.content || []} selection={true} sortBy={criteria.sort}
                                selectionChanged={selectionChanged} pageSizeChanged={pageSizeChanged} />
                        </CardContent>
                    </Card>
                </Grid>

                {action !== GLOBAL_ACTION.NONE && (
                    <Grid item xs={gridItemSize} paddingLeft={1}>
                        <AddProject data={edit} onDone={onDone} />
                    </Grid>
                )}

                <Modal
                    isOpen={isOpen}
                    title="Delete Items"
                    small={true}
                    deleteConfirmation={true}
                    ButtonDelete={deleteProject}
                />

                <Modal
                isOpen={openImport}
                title={t("Importing Files into Project")}
                small={true}
                 body={<ImportProjects  close={importClosed} />}
                deleteConfirmation={false}
            />

           
            {/* GLOBAL LIBRARY */}
                            {/* Segment Editor */}
                {(showSegmentEditor && !(upsertLibrary || upsertVariable || upsertGrammar || upsertPrompt || upsertAudio)) && (
                    <Grid item xs={gridItemSize} paddingRight={'9px'}>
                        {/* {showSegmentEditor && <div>{helpCenter && <div id="Segment Editor Help"  onClick={()=>dispatch(showHelpDetails('Segment Editor'))} className="help-icon-float"><InfoIcon /></div>}
                        
                        {<SegmentEditor 
                            segmentAddTestCaseEditor={segmentAddTestCaseEditor}
                            setSegmentAddTestCaseEditor={setSegmentAddTestCaseEditor}
                            projectLibrary={false} 
                            toggleSegmentEditor={toggleSegmentEditor} 
                            editorSource={editorSource || ''} // Add editorSource with default value
                            
                          //  setDiscardChangeConfirmation={} 
                            />}
                            </div>
                        } */}
                    </Grid>
                )}

                {/* Global/Project Library */}
                {(globalLibraryOpen) && (
                    <Grid item xs={gridItemSize} paddingRight={'9px'}>

                        {globalLibraryOpen && 
                            <div>{helpCenter && <div id="Global Library"  onClick={()=>dispatch(showHelpDetails('Global Library'))} className="help-icon-float"><InfoIcon /></div>}
                        <GlobalLibrary
                            toggleSegmentEditor={toggleSegmentEditor}
                            gridItemSize={gridItemSize}
                            editorOpen={editorOpen}
                            setEditorOpen={setEditorOpen}
                            selectedData={selectedData}
                            setSelectedData={setSelectedData}
                            editorState={editorState}
                            setEditorState={setEditorState}
                            caseEditorOpen={caseEditorOpen}
                            checkIsAnyEditorOpen={checkIsAnyEditorOpen}
                            discardChangeConfirmation={discardChangeConfirmation}
                            setDiscardChangeConfirmation={setDiscardChangeConfirmation}
                            setOpenDiscardConfirmation={setOpenDiscardConfirmation}
                            editorSource={editorSource} // Add editorSource
                            setEditorSource={setEditorSource} // Add setEditorSource
                            setSegmentAddTestCaseEditor={setSegmentAddTestCaseEditor}
                        
                        /></div>}
                    </Grid>
                )}

                {upsertLibrary && !editorOpen && (
                    <Grid item xs={gridItemSize} paddingRight={'9px'}>
                        {helpCenter && <div id="Segment Editor Help"  onClick={()=>dispatch(showHelpDetails('Segment Editor'))} className="help-icon-float"><InfoIcon /></div>}
                        
                    <SegmentEditor 
                        segmentAddTestCaseEditor={segmentAddTestCaseEditor}
                        setSegmentAddTestCaseEditor={setSegmentAddTestCaseEditor}
                            projectLibrary={true} 
                            editorSource={editorSource} 
                            toggleSegmentEditor={toggleSegmentEditor} 
                            setDiscardChangeConfirmation={setDiscardChangeConfirmation} />
                     </Grid>
                )}


                {/* Segment Editor */}
                {(upsertVariable || upsertGrammar || upsertPrompt || upsertAudio) && (
                    <Grid item xs={gridItemSize} paddingRight={'9px'}>
                        <LibraryEditor
                            selectedData={selectedData} //
                            setSelectedData={setSelectedData} //
                            editorOpen={true}
                            setEditorOpen={setEditorOpen} //
                            type={getTabType()}
                            project={0}
                            editorState={editorState} //
                            toggleSegmentEditor={toggleSegmentEditor}
                            setDiscardChangeConfirmation={setDiscardChangeConfirmation}
                            editorSource={editorSource} // Add editorSource
                            setEditorSource={setEditorSource} // Add setEditorSource

                        />
                    </Grid>
                )}

                {/* GLOBAL LIBRARY */}






                </Grid>
        </DndProvider>
        

    )
}